import React from "react";
import { Typography, Grid, Button } from "@mui/material";

import styled from "@emotion/styled";

import StrapiGrid from "./StrapiGrid";
import TheKahanoffCentre from "../assets/thekahanoffcentre.svg";
import purify from "dompurify";
// import Welcome from "../assets/welcome.svg";
export default function Hero({ isSmall, ...props }) {
  return (
    <Wrapper
      options={{
        alignContent: "center",
        alignItems: "center",

        sx: {
          padding: { xs: "0 2rem", sm: "0 4rem", md: 0 },
          height: { xs: 684, sm: 465, md: 600, lg: 704 },
          backgroundImage: `url(${TheKahanoffCentre}),url(${props?.Image?.data?.attributes?.url}),url(${props?.Image?.data?.attributes?.formats?.thumbnail?.url})`,
          backgroundSize: `80% ,cover,cover`,
          backgroundRepeat: `no-repeat`,
          backgroundPosition: `bottom center,center,center`,
        },
      }}
    >
      <Grid item align="left">
        <Typography
          align="left"
          dangerouslySetInnerHTML={{ __html: purify.sanitize(props?.Copy) }}
        />
        <Button variant="contained" href="/contact">
          For space, contact Tenant Relations
        </Button>
      </Grid>
      <Grid xs={12} md={3} align="right" item></Grid>
      {/* {!isSmall && <img id="logo" src={NavLogo} alt="The Kahanoff Centre" />} */}
    </Wrapper>
  );
}

const Wrapper = styled(StrapiGrid)`
  .MuiTypography-body1 {
    font-size: 1.5625rem;
    width: 100%;
    color: white;
    text-shadow: 0px 3px 14px #00000084;
    ${props => props.theme.breakpoints.up("sm")} {
      // width: 779px;
      white-space: pre;
    }
    ${props => props.theme.breakpoints.up("md")} {
      width: 779px;
      white-space: pre;
    }
  }
  .MuiButton-contained {
    background-color: ${props => props.theme.palette.common.white};
    color: ${props => props.theme.palette.common.black};
    font-size: 0.75rem;
    margin-top: 2rem;
    padding: 0 1.5rem;
    width: max-content;
    height: 65px;
    text-transform: uppercase;
    border-radius: 200px;
    border: none;
    font-weight: normal;
    &:after {
      content: unset;
    }
    &:hover {
      color: ${props => props.theme.palette.common.white};
      background-color: rgb(55, 147, 155);
      box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14),
        0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    }
    ${props => props.theme.breakpoints.up("md")} {
      font-size: initial;
      padding: 0.5rem 2.5rem;
    }
  }
`;
